import { Injectable, computed, signal } from '@angular/core';
import { ApiOrganization, ApiSurvey } from './api-organization.service';

@Injectable({ providedIn: 'root' })
export class OrganizationStoreService {
  private readonly _organizations = signal<ApiOrganization[]>([]);
  private readonly _selectedOrganization = signal<ApiOrganization | null>(null);
  private readonly _surveys = signal<ApiSurvey[]>([]);
  private readonly _selectedSurvey = signal<ApiSurvey | null>(null);

  organizations = this._organizations.asReadonly();
  selectedOrganization = this._selectedOrganization.asReadonly();
  surveys = this._surveys.asReadonly();
  selectedSurvey = this._selectedSurvey.asReadonly();

  selectedOrganizationId = computed(() =>
    this._selectedOrganization()?.id ?? null
  );

  selectedSurveyId = computed(() =>
    this._selectedSurvey()?.id ?? null
  );

  selectedOrganizationSurveys = computed(() =>
    this._selectedOrganization()?.surveys ?? []
  );

  setOrganizations(orgs: ApiOrganization[], preferredOrgId?: string | null): void {
    this._organizations.set(orgs);
    const savedId = localStorage.getItem('selectedOrganizationId');
    const selected =
      orgs.find(org => org.id === preferredOrgId) ??
      orgs.find(org => org.id === savedId) ??
      orgs[0] ??
      null;

    if (selected) {
      this.setOrganization(selected);
    }
  }

  setOrganization(org: ApiOrganization): void {
    this._selectedOrganization.set(org);
    localStorage.setItem('selectedOrganizationId', org.id);
    this.setSurveys(org.surveys);
  }

  setOrganizationById(orgId: string): void {
    const org = this._organizations().find(o => o.id === orgId);

    if (!org) {
      return;
    }

    this.setOrganization(org);
  }

  clearOrganization(): void {
    this._selectedOrganization.set(null);
    localStorage.removeItem('selectedOrganizationId');
  }

  getSelectedOrganizationSurveys(): ApiSurvey[] {
    return this._selectedOrganization()?.surveys ?? [];
  }

  // Surveys
  setSurveys(surveys: ApiSurvey[]): void {
    this._surveys.set(surveys);
    const savedId = localStorage.getItem('selectedSurveyId');
    const selected = surveys.find(s => s.id === savedId) ?? surveys[0] ?? null;

    if (selected) {
      this.setSurvey(selected);
    }
    else {
      this.setSurvey(surveys[0]);
    }
  }

  setSurvey(survey: ApiSurvey): void {
    this._selectedSurvey.set(survey);
    localStorage.setItem('selectedSurveyId', survey.id);
  }

  setSurveyById(surveyId: string): void {
    const survey = this._surveys().find(s => s.id === surveyId);

    if (!survey) {
      return;
    }

    this.setSurvey(survey);
  }

  clearSurvey(): void {
    this._selectedSurvey.set(null);
    localStorage.removeItem('selectedSurveyId');
  }
}